import {
    Button,
    Grid,
    Card,
    CardContent,
    CardHeader,
    Typography,
} from "@mui/material";
import * as React from 'react'
import { useSnackbar } from "notistack";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { LoadingButton } from "@mui/lab";
import { apiConstants, getGeneric, postGeneric } from "../../../common/constants";
import { FormProvider, RHFSelectField, RHFTextField } from "../../../common/hook-form";
import PageTitle from "../../../common/PageTitle";
import PageHero from "../../../common/PageHero";
import { getMerchant } from "../../../helpers/ReduxHelpers";
import Loader from "../../../common/Loader";
export default function UpdateB2COrder() {
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = React.useState(false);
    const [merchantData, setMerchantData] = React.useState(null);
    const [isInitialLoading, setIsInitialLoading] = React.useState(true);
    const merchant = getMerchant();


    React.useEffect(() => {
        setIsInitialLoading(true);
        getGeneric(`${apiConstants.MERCHANT_DETAILS}/${merchant?.id}`)
            .then((response) => {
                setMerchantData(response.data?.orderConversionCharges);
            })
            .catch((err) => {
                console.error(err);
            }).finally(() => setIsInitialLoading(false))
    }, [merchant?.id]);

    const UpdateOrderSchema = Yup.object().shape({
        taskType: Yup.string().required('Task type is required'),
        awb_number: Yup.string().required('AWB number is required'),
    });

    const method = useForm({
        resolver: yupResolver(UpdateOrderSchema),
        defaultValues: {
            taskType: "",
            awb_number: "",
        },
    })

    const {
        handleSubmit,
        reset,
    } = method;


    const onSubmit = (data) => {
        setLoading(true)
        const payload = {
            "taskType": data.taskType,
            "awb_number": data.awb_number,
        }
        postGeneric(`${apiConstants.EDIT_B2C_ORDER}`, payload).then((res) => {
            enqueueSnackbar("Success", { variant: 'success' })
            reset()
        }).catch((err) => {
            console.log(err);
            enqueueSnackbar(err.response?.data?.message ? err.response?.data?.message : "Some error occurred", { variant: 'error' })
        }).finally(() => setLoading(false))
    }


    return (
        <>
            {isInitialLoading ? (
                <Loader />
            ) : (
                <div id="main-content" className="container-fluid">
                    <PageTitle>Update Payment Mode</PageTitle>
                    <PageHero title="Update Payment Mode" subtitle="Convert a COD order to Prepaid by AWB number" sx={{ mb: 2.5 }} />
                    <Card sx={{ pb: 5 }}>
                        <CardHeader
                            title="Convert COD Order to Prepaid"
                            subheader="Use this form to change a Cash on Delivery (COD) order to a Prepaid order. Enter the AWB number of the order you want to update."
                        />
                        <CardContent sx={{ mt: 2 }}>
                            {!merchantData?.codToPrepadEnabled ? (
                                <Typography color="error" variant="subtitle1">
                                    COD to Prepaid conversion is not enabled for your account. To enable this feature Please connect with your respective account manager or sales POC.
                                </Typography>
                            ) : merchantData?.codToPrepad === null ? (
                                <Typography color="error" variant="subtitle1">
                                    COD to Prepaid conversion charges are not configured for your account. Please add charges to proceed.
                                </Typography>
                            ) : (
                                <FormProvider methods={method} onSubmit={handleSubmit(onSubmit)}>
                                    <Grid container spacing={2} sx={{ mt: 1 }}>
                                        <Grid item xs={4}>
                                            <RHFTextField label="AWB Number *" name="awb_number" />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <RHFSelectField
                                                width="100%"
                                                name="taskType"
                                                label={`Select Task Type *`}
                                                options={[{ value: 'COD_TO_PREPAID', label: 'COD to Prepaid' }]}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <LoadingButton variant="contained" size="small" type="submit" sx={{ mt: 1, borderRadius: 1 }} loading={loading}>Submit</LoadingButton>
                                            <Button variant="contained" size="small" color='error' sx={{ ml: 1, mt: 1, borderRadius: 1 }} onClick={() => { reset() }}>Reset</Button>
                                        </Grid>
                                    </Grid>
                                </FormProvider>
                            )}
                        </CardContent>
                    </Card>
                </div>
            )}
        </>
    )
}